import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course, CourseDateAnnotationSingle } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import DateAnnotation from "@shared/models/date-annotation"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import ObjectId from "@shared/util/object-id-gen"
import type CourseCalendarEditor from "cc-frontend/services/course-calendar-editor"
import _ from "lodash"

@tagName("")
export default class LessonMenuNoClass extends Component {
  // args
  dateString!: string
  courseDate!: CourseDateCombined
  closeMenu!: Function
  course!: Course
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  goBack!: Function

  //state
  menuName = ""
  shouldBumpOrDelete: "BUMP" | "DELETE" | "NO_LESSON" = "NO_LESSON"
  hasReceivedAttrs = false

  //services
  @service courseCalendarEditor!: CourseCalendarEditor

  // lifecycle
  didReceiveAttrs() {
    if (this.hasReceivedAttrs || _.isNil(this.courseDate)) return
    this.hasReceivedAttrs = true
    if (this.courseDate.cardStackId) {
      this.set("menuName", "ASK_IF_BUMP")
    } else {
      this.set("menuName", "ASK_IF_NOTE")
    }
  }

  @action
  afterAskIfBump(shouldBumpOrDelete) {
    this.set("shouldBumpOrDelete", shouldBumpOrDelete)
    this.set("menuName", "ASK_IF_NOTE")
  }

  @action
  afterAskIfLeaveNote(shouldLeaveNote) {
    if (shouldLeaveNote) {
      this.set("menuName", "EDIT_ANNOTATION")
    } else {
      this._turnDayOff(null, null, false)
      this.closeMenu()
    }
  }

  @action
  goBackFromAskIfNote() {
    // This means they had to have come from the ask if bump menu
    if (this.shouldBumpOrDelete === "BUMP" || this.shouldBumpOrDelete === "DELETE") {
      this.set("menuName", "ASK_IF_BUMP")
    } else {
      this.goBack()
    }
  }

  @action
  goBackFromEditAnnotation() {
    this.set("menuName", "ASK_IF_NOTE")
  }

  @action
  createAnnotation({ title, description, _isRange, _startDate, _endDate }) {
    this._turnDayOff(title, description, true)
    this.closeMenu()
  }

  _turnDayOff(title, description, showAnnotation) {
    // @ts-ignore The date Annotation model doesn't produce the right type signature
    let dateAnnotation: CourseDateAnnotationSingle = new DateAnnotation({
      id: ObjectId.create(),
      type: "date-annotation-course-custom-single",
      attributes: {
        title: title,
        description: description,
        isOff: true,
        dateString: this.dateString,
        showAnnotation: showAnnotation,
      },
    })
    this.courseCalendarEditor.turnOffAndBumpDeleteOrNothing({
      dateAnnotation: dateAnnotation,
      course: this.course,
      planbook: this.planbook,
      cardStackId: this.courseDate.cardStackId,
      rotationCalendar: this.rotationCalendar,
      dateString: this.dateString,
      bumpOrDelete: this.shouldBumpOrDelete,
    })
  }
}
